import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-extra-expense-report',
  templateUrl: './extra-expense-report.component.html',
  styleUrls: ['./extra-expense-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class ExtraExpenseReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  allData = [];
  loading:boolean = false;
  insuranceExpenses:boolean = true;
  normalExpenses:boolean = true;
  total:number = 0;
  showFilters:boolean = false;
  expand:boolean = false;

  constructor(private repServ:ReportService) { 
    this.date1.setDate(this.date1.getDate() - 30);
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.repServ.extraExpenseReport(this.date1, this.date2)
      .then(resp => {
        this.allData = resp;
        this.data = this.allData;
        this.insuranceExpenses = true;
        this.normalExpenses = true;

        this.calcTotal();
        this.showFilters = true;

        this.loading = false;
      });
  }

  filter() {
    const fv = [1,2,3,4];
    const sr = [5,6];
    this.data = this.allData.filter(d => (this.insuranceExpenses &&  sr.includes(d.et_type_id)) || (this.normalExpenses && fv.includes(d.et_type_id)));
    
    // this.data = this.allData.filter(d => (this.insuranceExpenses && d.unity_id) || (this.normalExpenses && !d.unity_id));
    this.calcTotal();
  }

  calcTotal() {
    this.total = this.data.map(d => d.quantity * d.price * (1 + d.iva*1)).reduce((ant, act) => ant + act, 0);
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/extra-expenses' + '?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&sr=' + this.insuranceExpenses + '&fv=' + this.normalExpenses, '_blank')
  }
}
